import fetch from 'isomorphic-fetch';
import API from 'api';

const FetchWrapper = {
    fetchRequest(method, url, params = {}) {
        return fetch(url, {...params, method}).then((response) => {
            return response.status === 200
                ? response.json()
                : response.json().then((err) => {
                      throw err;
                  });
        });
    },
    fetchGet(url) {
        return this.fetchRequest('GET', url, {
            headers: API.getBaseHeaders(),
        });
    },
    fetchPost(url, values, params = {}) {
        const headers = API.getBaseHeaders();
        headers['Content-type'] = 'application/json';

        params.body = JSON.stringify(values);
        params.headers = headers;

        return this.fetchRequest('POST', url, params);
    },
};

export default FetchWrapper;
